<template>
  <tr :class="{'isDeleting': isDeleting }">
    <td v-if="selectable">
      <div class="colCheckboxRequest form-group col col-6 col-md-4">
        <label class="kt-checkbox kt-checkbox--bold">
          <input
            type="checkbox"
            v-model="data.selected"
            :disabled="data.disabled"
            @input="onSelect(data)"
          />
          <span></span>
        </label>
      </div>
    </td>
    <td class="align-middle text-center">
      <span
        class="kt-badge kt-badge--brand kt-badge--lg badge-acronym"
        :class="`badge-acronym--${data.acronym_brand.toLowerCase()}`">{{ data.acronym_brand }}</span>
    </td>
    <td class="align-middle">{{ data.firstname }} {{ data.lastname }}</td>
    <td class="align-middle text-break reference_number_table">{{ data.reference_number }}</td>
    <td class="align-middle text-break">
      <router-link
        class="text-info"
        :class="{ 'disabled': isDuplicating || isSearching }"
        :to="{ name: 'opportunity-edit', params: { privateId: data.uuid }}">
        {{ data.opportunity_name || 'Untitled' }}
        <font-awesome-icon :icon="['fas', 'edit']" v-if="!data.stage_supplier_label" />
      </router-link>
    </td>
    <td class="align-middle">{{ data.departure_date | custom-date('MMMM d, yyyy') }}</td>
    <td class="align-middle" nowrap>
      <div style="display: inline-block; width: 100%">
        <div style="display: flex; flex-direction: column">
          <span
            class="badge badge-light text-capitalize w100 stage-supplier-label"
            :style="styleStageSupplier(data.id_stage_supplier)"
            v-if="data && data.id_stage_supplier">{{ data.stage_supplier_label }}</span>
        </div>
      </div>
      <svg
        v-if="data.approval_signature"
        class="iconSignatureList"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 554 385"
        style="enable-background:new 0 0 554 385;"
        xml:space="preserve"
      >
        <path
          class="st0"
          d="M262.6,317.1c2.9-3.8,5.8-7.5,8.8-11.3c7.4-9.3,15.1-18.2,26.9-22.3c12.5-4.4,25.1,3.7,25.6,16.9
                    c0.2,5.5-0.5,11-0.8,16.4c-0.1,2.1-0.3,4.2-0.5,7c11.7-3.6,21.3-9.3,30.1-16.5c8.9-7.2,14.9-16.4,19-27c2.9-7.5,9.9-11.6,17.8-11.2
                    c8.1,0.4,14.3,4.3,16.7,12c1.3,4.3,1.4,9.8-0.1,14c-9.4,27.3-29.2,45.2-54.4,57.6c-8,3.9-16.6,7-25.2,9.1
                    c-13.8,3.4-27.5,3.5-39.8-14.5c-10.1,10.1-21.7,16.7-36.5,13.4c-15.2-3.3-22.4-14.3-26.3-29.2c-2.2,1.8-4,3.2-5.7,4.7
                    c-16.1,14-32.3,27.9-52.1,36.5c-15.6,6.8-31.4,8.8-47.3,0.9c-8.9-4.4-15.7-11.2-20.7-19.7c-2-3.4-3.8-3.5-7.2-1.9
                    C73,360.5,55.2,369,37,376.8c-11,4.7-21.6-0.2-25.5-10.4c-3.9-10.3,1.1-19.9,12.1-24.9c18.5-8.4,36.7-17.3,55.1-25.8
                    c3.9-1.8,4.9-4.3,4.8-8.6c-1-33.5,5.3-65.3,22.7-94.3c8.9-14.9,21-26.6,38.5-30.4c7.6-1.7,16-1.6,23.7-0.2
                    c10,1.8,15.3,10.2,19.4,18.7c8.4,17.3,6,34.8-0.7,51.8c-11.3,28.7-30,52-53.2,72c-2.1,1.8-4.8,4.3-4.9,6.5c-0.2,3.7,6.1,9.1,10,9.2
                    c3.4,0.1,7.4-0.1,10.1-1.8c10.8-6.5,21.8-12.9,31.6-20.7c14.6-11.6,28.2-24.4,42.3-36.6c2.9-2.5,6-4.8,9.2-6.9
                    c12.7-8.1,28.9,0.4,29.2,15.5c0.2,7.8-0.3,15.7-0.5,23.5c0,0.9,0.3,1.9,0.4,2.8C261.8,316.7,262.2,316.9,262.6,317.1z M123.1,281.9
                    c0.5-0.2,1-0.3,1.3-0.6c13-14.1,23.9-29.4,29.3-48c1.2-4.2,0.9-8.9,1.3-13.6C137.8,221.7,123,263.3,123.1,281.9z"
        ></path>
        <polygon
          class="st0"
          points="476.8,234.2 401,260.2 358.7,188.4 427.2,11.8 545.3,57.5 "
        ></polygon>
      </svg>
    </td>
    <td class="align-middle">{{ data.updated_date.slice(0,10) | custom-date('MMMM d, yyyy') }}</td>
    <td class="align-middle" v-if="showEdit">
      <router-link
        class="btn btn-primary btn-wide btn-sm w90 mr-2"
        :class="{ 'btn-light': !canEdit, 'disabled': isDuplicating || isSearching }"
        :to="{ name: 'opportunity-edit', params: { privateId: data.uuid }}">
        <span v-if="canEdit">Edit</span>
        <span v-if="!canEdit">View</span>
      </router-link>
    </td>
    <td class="align-middle" v-if="showDuplicate">
      <button
        class="btn btn-outline-hover-danger kt-label-font-color-1 ml-2"
        :disabled="isDuplicating || isSearching"
        @click="duplicateOpportunity">
        <font-awesome-icon :icon="['far', 'copy']" size="3x" /></button>
    </td>
    <td class="align-middle" v-if="showDelete">
      <button
        class="btn btn-outline-hover-danger kt-label-font-color-1"
        :class="{ 'disabled': !canDelete(data.id_stage_supplier) }"
        :disabled="isDuplicating || isSearching"
        @click="deleteOpportunity(data.id_stage_supplier)">
        <font-awesome-icon :icon="['fas', 'trash-alt']" size="3x" /></button>
    </td>
  </tr>
</template>

<script>
import { OPPORTUNITY__STAGES } from '@/constants';

export default {
  name: 'OpportunityListRow',
  props: {
    data: {
      type: Object,
      required: true
    },
    meta: {
      type: Object,
      required: true
    },
    selectedRow: {
      type: Object,
      required: false
    },
    isDuplicating: {
      type: Boolean,
      required: true
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    isDeleting: {
      type: Boolean,
      required: false
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDuplicate: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    onSelect: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    canEdit () {
      const havePermissions = this.data && this.data.permissions
      if (havePermissions) {
        const canEdit = this.data.permissions.edit
        const canView = this.data.permissions.view
        if (!canEdit && canView) {
          return false
        }
        if (canEdit && canView) {
          return true
        }
      }
      return true
    }
  },
  methods: {
    duplicateOpportunity () {
      this.$emit('onDuplicate')
    },
    deleteOpportunity (stageId) {
      if (this.canDelete(stageId)) {
        this.$emit('onDelete')
      }
    },
    styleStageSupplier (id) {
      const STYLES = [
        { id: OPPORTUNITY__STAGES.SALES_IN_PROGRESS, backgroundColor: '#666666', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SALES_AWAITING_SUPPLIER, backgroundColor: '#FFCC33', color: '#666666' },
        { id: OPPORTUNITY__STAGES.SUPPLIER_IN_PROGRES, backgroundColor: '#666666', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SUPPLIER_DONE, backgroundColor: '#0099CC', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SALES_QUOTE_SENT, backgroundColor: '#2BC0A8', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD, backgroundColor: '#34981d', color: '#FFFFFF' },
        { id: OPPORTUNITY__STAGES.SALES_REVISION_REQUEST, backgroundColor: '#FFCC33', color: '#666666' }
      ]
      let found = STYLES.find(c => c.id === id)
      delete found.id
      return found || {}
    },
    canDelete (stageId) {
      const STAGES_DISALLOWED = [20, 21, 22, 23, OPPORTUNITY__STAGES.SALES_QUOTE_SENT_GO_AHEAD]
      const found = STAGES_DISALLOWED.find(s => s === stageId)
      return !found
    }
  }
}
</script>

<style lang="scss" scoped>
.w100 { width: 100%; }
.w-90 { width: 90%; }
.w90 { width: 90px; }
.badge-acronym {
  font-weight: 500;
  font-size: 1.4rem;
}
.badge-acronym--iv {
  background-color: #091F40;
}
.badge-acronym--cs {
  background-color: #0057A7;
}
.badge-acronym--t {
  background-color: #ED1941;
}
.badge-acronym--tc {
  background-color: #3182c5;
}
.badge-acronym--lg {
  background-color: #9a844a;
}

.isDeleting {
  background-color: #efefef;
  opacity: .5;
}
.btn.disabled, .btn:disabled {
  opacity: .3;
}
.stage-supplier-label {
  font-weight: 500;
}
</style>
